(function () {
  var toolbar = document.querySelector('[data-sv-collection-toolbar]');
  if (!toolbar) return;

  function closeAll() {
    toolbar.querySelectorAll('[data-sv-toolbar-panel]').forEach(function (panel) {
      panel.classList.remove('is-open');
    });
    document.body.classList.remove('sv-toolbar-panel-open');
  }

  toolbar.querySelectorAll('[data-sv-toolbar-open]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var name = trigger.getAttribute('data-sv-toolbar-open');
      var panel = toolbar.querySelector('[data-sv-toolbar-panel="' + name + '"]');
      if (!panel) return;
      // Close any other open panel first — both panels share the same fixed,
      // overlapping layout, so having two "is-open" at once (reachable by a
      // keyboard user tabbing past one panel's backdrop to the other trigger)
      // would stack them on top of each other.
      closeAll();
      panel.classList.add('is-open');
      document.body.classList.add('sv-toolbar-panel-open');
    });
  });

  toolbar.querySelectorAll('[data-sv-toolbar-close]').forEach(function (closer) {
    closer.addEventListener('click', closeAll);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });

  var sortSelect = toolbar.querySelector('[data-sv-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  // Mobile-only: release the sticky Filter/Sort bar once the grid has
  // scrolled past, instead of staying pinned for the rest of the page
  // (trust strip, related collections) — operator feedback: staying stuck
  // that long looked "weird" once you're well past the actual products.
  // Desktop already releases correctly via the CSS grid row sizing in
  // sv-collection-toolbar.liquid; this mirrors that same idea in JS since
  // mobile has no grid row to lean on. Same IntersectionObserver pattern
  // already used in sv-sticky-atc.js for the same kind of "unpin once past
  // X" behavior.
  var grid = document.querySelector('[id$="__sv_collection_grid"]');
  var toolbarWrapper = toolbar.closest('.shopify-section');
  if (grid && toolbarWrapper && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        toolbarWrapper.classList.toggle('sv-collection-toolbar-section--released', scrolledPast);
      },
      { threshold: 0 }
    );
    observer.observe(grid);
  }
})();
